import { Form, Input, InputNumber, message, Select, Spin, Switch } from 'antd'
import { saveOrUpdateFirstMenu } from '@/services/talkOrder.ts'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { baseURL } from '@/api'
import { SFormUploadImage } from 'shj-components'
import { AcceptType } from 'shj-components/dist/es/SFormUploadImage'
import { useFileUrlPrefix } from 'shj-utils'

const { TextArea } = Input
const { Option } = Select
const AddOrEditFirstMenuDom: React.FC<any> = forwardRef(({ record, fn, onClose, ...rest }, ref) => {
  const { companyList, roleList } = rest
  const [form] = Form.useForm()
  const [fileList, setFileList] = useState<any>([])
  const uploadFileUrl = baseURL + `/file-web/file/upload`
  const [imagePrefix] = useFileUrlPrefix()
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (record?.id) {
      if (record?.iconUrl) {
        const obj: any = {}
        obj.response = {}
        obj.response.data = {}
        obj.response.data.url = record?.iconUrl
        const nameArr = record?.iconUrl?.split('/')
        obj.response.data.name = nameArr?.[nameArr?.length - 1]
        setFileList([
          {
            uid: '1',
            name: nameArr?.[nameArr?.length - 1],
            url: record?.iconUrl?.startsWith('http')
              ? record?.iconUrl
              : imagePrefix + record?.iconUrl,
            status: 'done',
            ...obj,
          },
        ])
      }
      let arr: string[] = []
      record?.companyList?.forEach((item: any) => {
        arr?.push(item?.busId)
      })
      form?.setFieldsValue({ ...record, companyList: arr })
    }
  }, [])

  const onFinish = () => {
    return new Promise((resolve, reject) => {
      if (loading) {
        reject({})
        return false
      }
      setLoading(true)
      form
        .validateFields()
        .then((values: any) => {
          try {
            console.log(values, 22222)
            const newValues = { ...values }
            let arr: any = []
            values?.companyList?.forEach((item: string) => {
              companyList?.forEach((el: any) => {
                if (el?.id === item) {
                  arr?.push({
                    busCode: el?.code,
                    busName: el?.name,
                    busId: el?.id,
                    busType: 'menu',
                  })
                }
              })
            })
            newValues.companyList = arr
            newValues.iconUrl = newValues?.iconUrl?.[0]?.response?.data?.filePath
            if (record?.id) newValues.id = record?.id
            newValues.pid = 0
            saveOrUpdateFirstMenu(newValues)
              .then((res: any) => {
                message.success('操作成功')
                setLoading(false)
                resolve({})
              })
              .catch(() => {
                setLoading(false)
                reject({ msg: '操作失败' })
              })
          } catch (err) {
            setLoading(false)
            reject(err)
          }
        })
        .catch(err => {
          setLoading(false)
          reject({ msg: '验证失败' })
        })
    })
  }

  useImperativeHandle(
    ref,
    () => ({
      form,
      onFinish,
    }),
    [form, onFinish]
  )

  return (
    <Spin spinning={loading}>
      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item
          label="适用门店"
          name="companyList"
          rules={[{ required: true, message: '不能为空' }]}
        >
          <Select
            placeholder="请选择适用门店"
            allowClear
            mode="multiple"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().indexOf(input?.toLowerCase()) >= 0
            }
          >
            {companyList?.map((item: any) => {
              return (
                <Option key={item.id} value={item.id}>
                  {item.name}
                </Option>
              )
            })}
          </Select>
        </Form.Item>
        <Form.Item label="一级菜单" name="name" rules={[{ required: true, message: '不能为空' }]}>
          <Input placeholder="请输入一级菜单名称" maxLength={20} />
        </Form.Item>
        <Form.Item label="一级菜单别名" name="alias">
          <Input placeholder="请输入一级菜单别名" maxLength={10} />
        </Form.Item>
        <Form.Item
          label="一级菜单编码"
          name="code"
          rules={[{ required: true, message: '不能为空' }]}
        >
          <Input placeholder="请输入一级菜单编码" maxLength={20} />
        </Form.Item>
        <Form.Item
          label="菜单地址"
          name="routeUrl"
          rules={[{ required: true, message: '不能为空' }]}
        >
          <Input placeholder="请输入菜单地址" />
        </Form.Item>
        <Form.Item label="排序" name="sortNumber" rules={[{ required: true, message: '不能为空' }]}>
          <InputNumber style={{ width: '100%' }} min={0} max={9999}/>
        </Form.Item>
        <Form.Item label="谈单时适用角色" name="roleIds">
          <Select
            allowClear
            showSearch
            mode="multiple"
            optionFilterProp="label"
            options={roleList}
          />
        </Form.Item>
        <Form.Item label="菜单图标" name="iconUrl">
          <SFormUploadImage
            maxCount={1}
            accept={AcceptType.picture}
            fileList={fileList}
            url={uploadFileUrl}
            listType="text"
          />
        </Form.Item>
        <Form.Item label="是否启用" name="status" valuePropName="checked">
          <Switch />
        </Form.Item>
        <Form.Item label="备注" name="remark">
          <TextArea maxLength={300} placeholder="请输入备注" rows={3} />
        </Form.Item>
      </Form>
    </Spin>
  )
})

export default AddOrEditFirstMenuDom
